import {ORDER_METHODS, RoomServiceLocationType} from "../../../../../services/exports/Constants";

export default {
  more_info: 'Mehr Info',
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: '{{time}} min Zimmerservice',
      [RoomServiceLocationType.TableService]: '{{time}} min Vor Ort',
      both: '{{time}} min Tisch/Zimmer-service',
    },
    [ORDER_METHODS.PICKUP]: '{{time}} min Abholung',
    [ORDER_METHODS.DELIVERY]: '{{time}} min Lieferung',
  },
  pickup: '{{time}} min Abholung: ',
  delivery: '{{time}} min Lieferung: ',
  labels: {
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
  },
  buttons: {
    change_store: 'Store wechseln',
  },
};
